<template>
  <a-row :gutter="[16,16]">
    <a-col>
      <a-card hoverable>
        <a-card-meta :title="nombre">
          <a-avatar
            slot="avatar"
            :src="profileSrc"
            @click="agrandarImg()"
            :size="tamanoimg"
          />
          <span slot="description">
            {{identificacion}}
        <a-alert v-show="veto" message="Esta persona se encuentra SIN_CONCEPTO_OPERATIVO, validar en atributos carácter." type="warning" show-icon />
          </span>
        </a-card-meta>
        <template class="ant-card-actions" slot="actions">
          <a-row>
            <a-col :xs="24" :xl="12">
              <a-tag v-if="edad" color="blue">
                <a-icon type="gift"/>
                Edad: {{edad}}
              </a-tag>
            </a-col>
            <a-col :xs="24" :xl="12">
              <a-progress style="width: 80%" :percent="100" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }"/>
            </a-col>
          </a-row>
        </template>
      </a-card>
    </a-col>
    <a-modal @ok="() => {this.expandImg = false}" :cancel-button-props="{props: { disabled: true } }" width="400px"
             v-model="expandImg" :title="nombre">
      <a-card hoverable style="width: auto">
        <img
          slot="cover"
          :src="profileSrc"
        />
      </a-card>
    </a-modal>
  </a-row>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        expandImg: false,
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png'),
        veto: false
      }
    },
    props: ['persona', 'tamanoimg', 'edad'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.identificacion && this.loadPersonPicture(this.identificacion)
    },
    methods: {
      agrandarImg () {
        this.expandImg = true
      },
      loadPersonPicture (idPerson) {
        this.validaBeto(idPerson)
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      validaBeto (idPerson) {
        this.httpClient.getInstance().get('employee/valida_veto/' + idPerson)
          .then(({data}) => {
            this.veto = data
          })
      }
    },
    watch: {
      persona () {
        if (JsUtils.isEmpty(this.persona)) {
          this.profileSrc = this.defaultPicture
          this.veto = false
        }
        this.identificacion && this.loadPersonPicture(this.identificacion)
      }
    },
    computed: {
      nombre () {
        return JsUtils.isEmpty(this.persona) ? '' : (JsUtils.isEmpty(this.persona.nombre) ? '' : this.persona.nombre)
      },
      identificacion () {
        return JsUtils.isEmpty(this.persona) ? '' : (JsUtils.isEmpty(this.persona.identificacion) ? '' : this.persona.identificacion)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeSummary.vue